<template>
  <v-app dark>
    <main>
      <v-container fluid fill-height>
        <v-layout>
          <v-flex sm6 offset-sm3>
            <v-card>
              <v-container :class="{ 'error' : hasErrors }">
                <v-card class="elevation-0">
                    <v-card-text>
                      <v-container fluid>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              name="name"
                              label="Username"
                              v-model.trim="name"
                              required
                              dark
                              >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              type="email"
                              name="email"
                              label="Email"
                              v-model.trim="email"
                              required
                              dark
                              >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              type="password"
                              name="password"
                              label="Password"
                              v-model.trim="password"
                              required
                              dark
                              >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              type="password"
                              name="password_confirmation"
                              label="Confirm Password"
                              v-model.trim="password_confirmation"
                              required
                              dark
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                          <v-btn
                            success
                            @click.prevent="register"
                            >
                            Register
                          </v-btn>
                          <div>
                             <p class="text-xs-right">Already Signed Up? <router-link class="success--text" to="/login">Login</router-link></p>
                          </div>
                      </v-container>
                    </v-card-text>
                </v-card>
              </v-container>
            </v-card>
            <div class="error" v-if="hasErrors">
                <p v-for="error in errors">{{ error }}</p>
            </div>
          </v-flex>
        </v-layout>
        <!--v-router-->
      </v-container>
    </main>
  </v-app>

</template>

<script>
import firebase from 'firebase'
import md5 from 'md5'

export default {
  name: 'register',
  data () {
    return {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      errors: [],
      usersRef: firebase.database().ref('users')
    }
  },
  computed: {
    hasErrors () {
      return this.errors.length > 0
    }
  },
  methods: {
    register () {
      this.errors = []

      if (this.isFormValid()) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(user => {
            user
              .updateProfile({
                displayName: this.name,
                photoURL:
                  'https://www.gravatar.com/avatar/' +
                    md5(user.email) +
                    '?d=wavatar'
              })
              .then(
                () => {
                  this.saveUserToUsersRef(user).then(() => {
                    this.$store.dispatch('setUser', user)
                    this.$router.push('/')
                  })
                },
                error => {
                  console.log(error)
                  this.errors.push(error.message)
                }
              )
          })
          .catch(error => {
            console.log(error)
            this.errors.push(error.message)
          })
      }
    },
    saveUserToUsersRef (user) {
      return this.usersRef.child(user.uid).set({
        name: user.displayName,
        avatar: user.photoURL
      })
    },
    isEmpty () {
      if (
        this.name.length === 0 ||
        this.email.length === 0 ||
        this.password.length === 0 ||
        this.password_confirmation.length === 0
      ) {
        return true
      }
      return false
    },
    passwordValid () {
      if (this.password.length < 6 || this.password_confirmation.length < 6) {
        return false
      }
      if (this.password !== this.password_confirmation) {
        return false
      }
      return true
    },
    isFormValid () {
      if (this.isEmpty()) {
        this.errors.push('Please complete all fields')
        return false
      }
      if (!this.passwordValid()) {
        this.errors.push('Incorrect password')
        return false
      }
      return true
    }
  }
}

</script>

<style lang="stylus">
  @import '../stylus/main'
  .error
    padding: 5px 5px 0
    background-color: #444 !important
    border:1px solid #ff5252 !important
</style>



// WEBPACK FOOTER //
// Register.vue?c90e2f2c